module.exports = __webpack_public_path__ + "img/icon-pay.3336d336.svg";